// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"a10a3f92e9--wrapper--1GFHU","label":"a10a3f92e9--label--3OwDq"};